<div class="main-score-container">
    <div class="header">
        <div class="event-time">
            @if (isEpcotEnabled && showPreMatchTimer) {
                <ms-scoreboard-timer [event]="event" />
            } @else {
                <span class="date">{{ date }}</span>
                <span class="time">{{ event.startDate | date: 'shortTime' }}</span>
            }
            @if (broadcaster$ | async; as broadcaster) {
                <label class="broadcast-info">{{ broadcaster }} </label>
            }
            @if (!isEpcotEnabled && showPreMatchTimer) {
                <ms-scoreboard-timer [event]="event" />
            }
            <span class="event-description" *ngIf="isNewEDPScoreboard">{{ event.description }}</span>
        </div>
    </div>
    <ng-container *ngFor="let participant of event.participants; let i = index">
        <div class="participant">
            <ms-participant-image
                class="participant-logo"
                *ngIf="!isDoublesPlayer"
                [participantImage]="participant.image"
                [sportId]="event.sport.id"
                [shouldRotate]="rotateImage[i]"
                [showLogoColor]="showLogoColor">
            </ms-participant-image>
            <ms-scoreboard-participant
                class="participant-info"
                [event]="event"
                [participant]="participant"
                [showIndicator]="false"
                [isNewEDPScoreboard]="isNewEDPScoreboard"
                [participantInfo]="participantInfos[i]">
            </ms-scoreboard-participant>
        </div>
    </ng-container>
</div>

<span class="league-name" *ngIf="isShowLeagueName">{{ event.league.name }}</span>
